module.exports = __webpack_public_path__ + "static/media/career_content_4.b4e24c3b.png";